import { createContext, FunctionComponent, ReactNode, useContext, useMemo } from 'react';

import { ButtonSSTStyleContext } from 'inquiry/context/ButtonSSTStyleContext';
import { serializeStepGovernmentIdStyles } from 'inquiry/lib/inquiry';
import {
  SerializedStepGovernmentIdStyles,
  StepGovernmentIdStyles,
} from 'lib/interfaces/StepsConfig';

export const StepGovernmentIdStyleContext = createContext<SerializedStepGovernmentIdStyles>(
  serializeStepGovernmentIdStyles(),
);

export const useStepGovernmentIdStyleContext = () => useContext(StepGovernmentIdStyleContext);

export const StepGovernmentIdStyleProvider: FunctionComponent<{
  children: ReactNode;
  value: StepGovernmentIdStyles | null | undefined;
}> = ({ children, value }) => {
  const serializedStyles = useMemo(() => serializeStepGovernmentIdStyles(value), [value]);

  return (
    <StepGovernmentIdStyleContext.Provider value={serializedStyles}>
      <ButtonSSTStyleContext.Provider value={serializedStyles.buttons}>
        {children}
      </ButtonSSTStyleContext.Provider>
    </StepGovernmentIdStyleContext.Provider>
  );
};
